module.exports = "https://cdn.ticketswap.com/_next/static/images/theatre-comedy-be44d9f1e537548ffd41b67ad0c0c9c1.jpg";